import React from 'react';
import SideNav from './sidenav';
import { ReactComponent as ArrowSvg } from '../../../assets/images/arrow/icon_arrow_down.svg';
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
const ApiContent = ({ id, innerWidth, content }) => {
    return (
        <div className='api-pg' id="content-box">
            <div className="api-wrap">
                {/* mobile sidenav section start */ }
                {
                    innerWidth < 1200 &&
                    <div className="mobilesidenav" id="mobilesidenav">
                        <div className="inner-box">
                            <SideNav
                                currentPath={ id }
                                expandIcon={ <ArrowSvg /> }
                                isFixed={ true } />
                        </div>
                    </div>
                }
                {/* mobile sidenav section end */ }
                <div className="container">
                    <div className="row-wrap mx-0 sticky-parent">
                        <SideNav
                            topId="content-box"
                            currentPath={ id }


                            expandIcon={ <ArrowSvg /> }
                            isFixed={ true } />
                        <div className="nav-content content-box">
                            <div className="info-box">
                                {
                                    !!content.flexible_content.length && content.flexible_content.map((obj, index) => {
                                        return (
                                            <div key={ index }>
                                                {
                                                    obj.section_title_heading && obj.section_title_heading === "h1" ? <h1 dangerouslySetInnerHTML={{ __html: obj.section_title }}/> : obj.section_title_heading === "h2" ? <h2 dangerouslySetInnerHTML={{ __html: obj.section_title }}/> : null
                                                }
                                                {
                                                    obj.acf_fc_layout && obj.acf_fc_layout === "simple_content" &&
                                                    <div dangerouslySetInnerHTML={ { __html: obj.section_content } }
                                                    ></div>
                                                }
                                                {
                                                    obj.grey_background_content && obj.grey_background_content !== "" && <div className='full-width-card'>
                                                        <div className="card">
                                                            <div className="inner-box" dangerouslySetInnerHTML={ { __html: obj.grey_background_content } }>

                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                                {
                                                    obj.cta_button && obj.cta_button !== "" && <div className="button-box">
                                                        <a href={ obj.cta_button.url } target={ obj.cta_button.target !== "" ? "_blank" : "_self" } className='button button-solid big-size'>{ obj.cta_button.title }</a>
                                                    </div>
                                                }
                                                {
                                                    obj.acf_fc_layout && obj.acf_fc_layout === "code_panel_content" &&
                                                    <div className="code-panel">
                                                        <div className="panel-heading">{ obj.section_title }</div>
                                                        <div className="panel-body">
                                                            {
                                                                obj.section_body_color === "white-cls" && <pre rel="HTML" >
                                                                    <code className={ `${obj.section_body_color === "white-cls" ? "content-white" : "content-yellow"}` } dangerouslySetInnerHTML={ { __html: obj.section_content } } />
                                                                </pre>
                                                            }

                                                            {
                                                                obj.section_body_color === "yellow-cls" && <pre rel="jsx" data-line="">
                                                                    <PerfectScrollbar component='code'
                                                                        // className="slideBg"
                                                                        options={ {
                                                                            wheelSpeed: 0.8,
                                                                            wheelPropagation: true,
                                                                            minScrollbarLength: 20,
                                                                            swipeEasing: true,
                                                                            handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
                                                                        } }>
                                                                        <code className={ ` has-curlybraces ${obj.section_body_color === "white-cls" ? "content-white" : "content-yellow"}` } dangerouslySetInnerHTML={ { __html: obj.section_content } } />
                                                                    </PerfectScrollbar>
                                                                </pre>
                                                            }

                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        );
                                    })
                                }
                                {/* <h1>Payment Gateway</h1>
                                <p>More than 14,000,000 customers use Revolut to manage their personal or business finances. Each customer is different and Revolut is on a mission to become the financial super-app that meets their unique needs. This is where you come in. </p>
                                <p>Join the 1000+ developers who have already built applications using the Revolut APIs.</p>

                                <table>
                                    <thead>
                                        <tr>
                                            <th>API</th>
                                            <th>For who</th>
                                            <th>What can you do</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Open Banking API</td>
                                            <td>Third Party Developers</td>
                                            <td>Create applications for the marketplace or integrate Revolut into your own app for Revolut customers.</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <h2>PSDII regulated Third Party Providers</h2>
                                <p>Third Party Providers (TPPs) are authorised online service providers that have been introduced as part of Open Banking. If you are engaged in the provision of the payment initiation or account information transaction in the European Union (EU) or the United Kingdom (UK), you will have to be regulated by financial regulatory bodies in the relevant jurisdictions. In order to get access to our Open Banking API you will need to use a valid eIDAS certificate or Open Banking (OB) certificate to register your application on production.</p>

                                <div className='full-width-card'>
                                    <div className="card">
                                        <div className="inner-box">
                                            <p>eIDAS certificates are issued by Qualified Trust Service Providers (QTSPs) that are in the <a href="#">European List of Trusted Lists</a>. Just check the QWAC and QCSEAL, choose your country, and get the list. The good news is, you can get the certificate anywhere in the EU, not just your own country.</p>
                                        </div>
                                    </div>
                                </div>

                                <h2>Introduction</h2>
                                <p>The goal of this quickstart is to get you to your first API request as soon as possible. </p>

                                <p>To begin using the API you’ll start by setting up a sandbox environment where you can execute the exact same functionality as in production. You can use this to test your integration before going live. To set up a sandbox environment, please head over to the developer portal and create your sandbox certificates.</p>

                                <div className="button-box">
                                    <a href="#" className='button button-solid big-size'>Create account on developer portal</a>
                                </div>

                                <div className="code-panel">
                                    <div className="panel-heading">Generate RSA</div>
                                    <div className="panel-body">
                                        <pre rel="HTML" >
                                            <code className="content-white">
                                                <p>openssl genrsa -out server.key 2048</p>
                                            </code>
                                        </pre>
                                    </div>
                                </div>

                                <h2>Working with the Sandbox environment</h2>
                                <p>For the sake of creating a sandbox account, you can create some dummy certificates on your local machine. First, you’ll need to generate an RSA using the openssl command.</p>
                                <p>Then, we can generate X.509 Certificate Signing Request (CSR) using the second command. </p>
                                <p>Now, take the CSR file you just created with the last command and upload it to the sandbox environment.</p>

                                <div className="button-box">
                                    <a href="#" className='button button-solid big-size'>Upload Certificate Signing Request</a>
                                </div>

                                <div className="code-panel">
                                    <div className="panel-heading">JWT Payload</div>
                                    <div className="panel-body">

                                        <pre rel="jsx" data-line="">
                                            <PerfectScrollbar component='code'
                                                // className="slideBg"
                                                options={ {
                                                    wheelSpeed: 0.8,
                                                    wheelPropagation: true,
                                                    minScrollbarLength: 20,
                                                    swipeEasing: true,
                                                    handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
                                                } }>
                                                <code className="content-yellow has-curlybraces">
                                                    &#123;
                                                    <p>"iss": "test-iss",</p>
                                                    <p>"iat": <em>1591352490</em>,</p>
                                                    <p>"exp": <em>1591356090</em>,</p>
                                                    <p>"aud": "https://revolut.com",</p>
                                                    <p>"scope": ["openid", "payments", "accounts", "fundsconfirmations"],</p>
                                                    <p>"redirect_uris": ["http://url/one"],</p>
                                                    <p>"application_type": "web",</p>
                                                    <p>"id_token_signed_response_alg": "PS256",</p>
                                                    <p>"request_object_signing_alg": "PS256",</p>
                                                    <p>"tls_client_auth_dn": "test-dn",</p>
                                                    <p>"software_statement": "ewogICJhbGciOiAibm9uZSIKfQ.ewogICJvcmdfaWQiOiAiNzc3NTgwMDAwMTAzVUF2QUFNIiwKICAib",</p>
                                                    &#125;
                                                </code>
                                            </PerfectScrollbar>
                                        </pre>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApiContent;